let entryTime = performance.now()
let timeOnSite = 0

if ('onvisibilitychange' in document && 'visibilityState' in document) {
  addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      timeOnSite += (performance.now() - entryTime)
      let data = new FormData;
      data.append('timeOnSite',Math.floor(timeOnSite/1000));
      navigator.sendBeacon("/", data)
    }
    else if (document.visibilityState === "visible") {
      entryTime = performance.now()
    }
  })
} else if ('onblur' in window && 'onfocus' in window && 'onbeforeunload' in window) {
  document.querySelector('body').onblur = function () {
    timeOnSite += (performance.now() - entryTime)
    let data = new FormData;
    data.append('timeOnSite',Math.floor(timeOnSite/1000));
    navigator.sendBeacon("/", data)
  }

  document.querySelector('body').onfocus = function () {
    entryTime = performance.now()
  }

  addEventListener("beforeunload", () => {
    let data = new FormData;
    data.append('timeOnSite',Math.floor(timeOnSite/1000));
    navigator.sendBeacon("/", data)
  })
}
